module.exports = __webpack_public_path__ + "img/image3.afe33d67.svg";